import axios from 'axios';

class Services {
    
    getErrors({response}){
        let errors = null ;
        if( response && response.status >=500 ) {
            let { data } = response || {};
            errors = { ...data, error: true, status:response.status}
        }
        return errors;
    }

    async GET(API_URL, headers) {
        try{
            const response =  await axios.get(API_URL, headers);
            return response.data;
        }
        catch(e) {
            let errors = await this.getErrors(e);
            return errors;
        }
    }

    async POST(API_URL, data, header) {
        try{
            const response =  await axios.post(API_URL, data, header);
            return response.data;
        }
        catch(e) {
            let errors = await this.getErrors(e);
            return errors;
        }
    }
    async POSTBLOB(API_URL, data) {
        try{
            const response =  await axios.post(API_URL,data , { responseType :'blob'});
            return response.data;
        }
        catch(e) {
            let errors = await this.getErrors(e);
            return errors;
        }
    }

    async GETBLOB(API_URL) {
        try{
            const response =  await axios.get(API_URL,{ responseType :'blob'});
            return response.data;
        }
        catch(e) {
            let errors = await this.getErrors(e);
            return errors;
        }
    }

    async PUT(API_URL, data, header) {
        try{
            const response =  await axios.put(API_URL, data, header);
            return response.data;
        }
        catch(e) {
            let errors = await this.getErrors(e);
            return errors;
        }
    }
    async DELETE(API_URL, data, header) {
        try{
            const response =  await axios.delete(API_URL, data, header);
            return response.data;
        }
        catch(e) {
            let errors = await this.getErrors(e);
            return errors;
        }
    }
}
export const HTTP = new Services();